import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { WorkCenter } from '../workcenters/work-center'
import { ControlCenter } from './control-center'

export class ControlCenterFilter {
  public static readonly TYPES_KEY = 'types'

  public static types(...types: string[]): Filter {
    return new Filter(ControlCenterFilter.TYPES_KEY, types)
  }
}

@Injectable({
  providedIn: 'root',
})
export class ControlCenterService extends RestClientPaged<ControlCenter, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/control-centers', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findControlCentersFor(wc: WorkCenter): Observable<ControlCenter[]> {
    if (wc?.workStations?.length > 0) {
      return this.findAllPaged(new Pageable(0, 10), [
        new Filter('workStations', wc.workStations),
      ]).pipe(map((page) => page.content))
    } else {
      return of([])
    }
  }
}
